export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const URL_REGEX = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
export const URL_OR_EMPTY_REGEX = /^$|(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
export const SO_DEV_STORY_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/(story|cv|users\/story)\/(.)+$/i;
export function isValidDevStorySOURL(url) {
    return SO_DEV_STORY_URL_REGEX.test(url);
}
export const SO_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
export const SO_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
export function isValidSOURL(url) {
    return SO_URL_REGEX.test(url);
}
export const TWITTER_URL_REGEX = /^https:\/\/(www\.)?twitter\.com\/(.)+$/i;
export const TWITTER_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?twitter\.com\/(.)+$/i;
export function isValidTwitterURL(url) {
    return TWITTER_URL_REGEX.test(url);
}
export const GITHUB_URL_REGEX = /^https:\/\/(www\.)?github\.com\/(.)+$/i;
export const GITHUB_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?github\.com\/(.)+$/i;
export function isValidGitHubURL(url) {
    return GITHUB_URL_REGEX.test(url);
}
export function isValidURL(url) {
    return URL_REGEX.test(url);
}
export function isValidURLOrEmpty(url) {
    return URL_OR_EMPTY_REGEX.test(url);
}
//# sourceMappingURL=index.js.map